import '../sass/app.scss';

import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

// import externalLinks from './components/external-links';
import gaMaps from './components/maps';

import 'lity/dist/lity.min';
import './components/gallery';
import './components/news';
import './components/nav';
import './components/teams';
import './components/video-slider';

document.addEventListener('DOMContentLoaded', () => {
	gaMaps.init();
});
